import {Pipe, PipeTransform, SecurityContext} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

@Pipe({
    name: 'safeHtml',
    standalone: false
})
export class SafeHtmlPipe implements PipeTransform {
    constructor(private sanitized: DomSanitizer) {
    }

    transform(value: any) {
        return this.sanitized.sanitize(SecurityContext.HTML, value);
    }

}

@Pipe({
    name: 'safeHtmlURL',
    standalone: false
})
export class SafeHtmlURLPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {
    }

    transform(html: any) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(html);
    }
}
